import StackTrace from 'stacktrace-js'

export const processStack = async (error: Error) => {
  const stack = await StackTrace.fromError(error)
  return stack
    .map(
      (row) => `${row.fileName}:${row.lineNumber || 0}:${row.columnNumber || 0}`
    )
    .join('\n')
}
